module.exports = __webpack_public_path__ + "static/media/hidden.23f4cc1a.svg";